module.exports = __webpack_public_path__ + "img/制御工学3_10_4.3c4ae7ab.png";